<template>
  <div class="sa-free-page">
    <div class="sa-free-page-body">
      <b-row>
        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
          <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
              <b-card class="sa-card" header="Dati Agenda" header-tag="header" footer-tag="footer" title="">
                <b-row>
                  <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">{{ this.$i18n.t("agendas.lblTitle") }}</label>
                    <b-form-input @input="onInput()" v-model="jsonData.titolo"
                      :placeholder="this.$i18n.t('agenda.lblEnterTitle')"></b-form-input>
                  </b-col>
                  <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">{{ this.$i18n.t("agenda.lblAgendaIdentifier") }}</label>
                    <b-form-input v-model="jsonData.identificativo"
                      :placeholder="this.$i18n.t('agenda.lblEnterIdentifier')"></b-form-input>
                  </b-col>
                  <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">Presidio</label>
                    <b-form-select v-model="jsonData.idPresidio" :placeholder="'Presidio'">
                      <template #first>
                        <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
                      </template>
                      <template>
                        <b-form-select-option v-for="pres of presidiOptions" :value="pres.id" :key="pres.id"> {{
                          pres.denominazione }} ({{ pres.denominazioneStruttura }}) </b-form-select-option>
                      </template>
                    </b-form-select>
                  </b-col>
                  <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">Tipo Agenda</label>
                    <b-form-select v-model="jsonData.tipo" :placeholder="'Tipologia Agenda'">
                      <template>
                        <b-form-select-option v-for="pres of tipologieAgendaOptions" :value="pres.nome"
                          :key="pres.nome"> {{
                            pres.nome }} </b-form-select-option>
                      </template>
                    </b-form-select>
                  </b-col>
                  <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">Specializzazione</label>
                    <b-form-select v-model="jsonData.specializzazione" :placeholder="'Presidio'">
                      <template #first>
                        <b-form-select-option :value="null">Nessuna</b-form-select-option>
                      </template>
                      <template>
                        <b-form-select-option v-for="pres of specializzazioniOptions" :value="pres.nome"
                          :key="pres.nome"> {{
                            pres.nome.toUpperCase() }} </b-form-select-option>
                      </template>
                    </b-form-select>
                  </b-col>
                  <b-col cols="12" xs="12" sm="12" md="5" lg="5" xl="5">
                    <label class="sa-label-data">{{ this.$i18n.t("agenda.lblDurationAppointment") }}</label>
                    <b-form-input v-model="jsonData.durataAppuntamento"></b-form-input>
                  </b-col>
                  <b-col cols="12" xs="12" sm="12" md="5" lg="5" xl="5">
                    <label class="sa-label-data">{{ this.$i18n.t("patient.agenda.lblProprietario") }}</label>
                    <b-form-input v-model="jsonData.proprietario"
                      :placeholder="this.$i18n.t('agenda.lblEnterOwner')"></b-form-input>
                  </b-col>
                  <b-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                    <label class="sa-label-data">{{ this.$i18n.t("agenda.lblExtraTime") }}</label>
                    <b-form-checkbox v-model="jsonData.extraTime" name="check-button" switch></b-form-checkbox>
                  </b-col>
                  <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Descrizione</label>
                    <b-form-textarea class="form-control" v-model="jsonData.descrizione" rows="5" no-resize
                      :placeholder="this.$i18n.t('agenda.lblEnterDescription')"></b-form-textarea>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
          <!-- <div class="sa-card-fill-height"> -->
          <b-card class="sa-card" header="Intervalli" header-tag="header" footer-tag="footer" title=""
            style="height: 364px;">
            <template #header>
              <div style="display: flex">
                <span style="flex: 1">Intervalli</span>
                <b-button size="sm" variant="outline-secondary outline-secondary-noborder pull-right"
                  @click="onClickNuovoParametro()">
                  <i class="fas fa-plus"></i>
                  Aggiungi
                </b-button>
              </div>
            </template>
            <div style="height: 300px !important; overflow-y: scroll; border-radius: 8px !important;">
              <div v-for="parametro, i in jsonData.parametri" :key="i">
                <div class="sa-utility-edit-toolbar">
                  <span>{{ getDay(parametro.giorno) }}</span>
                  <b-button size="sm" variant="outline-secondary outline-secondary-noborder pull-right "
                    @click="onClickAggiungiFasciaOrario(parametro, i)">
                    <i class="fas fa-plus"></i>
                    Aggiungi Fascia Orario
                  </b-button>

                  <b-button size="sm" class="ml-3" variant="outline-primary outline-primary-noborder pull-right "
                    @click="onClickModificaParametro(parametro, i)">
                    <i class="bi bi-pencil"></i>
                  </b-button>

                  <b-button size="sm" class="ml-3" variant="outline-danger outline-danger-noborder pull-right "
                    @click="onClickRimuovi(parametro, i)">
                    <i class="fas fa-trash"></i>
                  </b-button>
                </div>
                <ul>
                  <li v-for="(intervallo, index) in parametro.intervalli" :key="intervallo.id">
                    <diV class="sa-agenda-intervallo-fascia-oraria">
                      {{ intervallo.dalleOre }} - {{ intervallo.alleOre }}
                      <b>Numero accessi:</b>
                      {{ intervallo.numeroAccessi }}
                      <b-button size="sm" variant="outline-primary outline-secondary-noborder pull-right "
                        @click="onClickModificaIntervallo(intervallo, index, parametro, i)">
                        ✏️
                      </b-button>
                      <b-button size="sm" class="ml-3" variant="outline-danger outline-danger-noborder pull-right "
                        @click="onClickEliminaFasciaOrario(parametro, i)">
                        <i class="fas fa-trash"></i>
                      </b-button>
                    </diV>
                  </li>
                </ul>
              </div>
            </div>
          </b-card>
          <!-- </div> -->
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
          <b-card class="sa-card" header="Prestazioni Agenda" header-tag="header" footer-tag="footer" title="">
            <template #header>
              <div style="display: flex">
                <span style="flex: 1">Prestazioni Agenda</span>
                <span>
                  <b-button size="sm" variant="outline-secondary outline-secondary-noborder pull-right"
                    @click="onClickNuovoPrestazioniAgenda()">
                    <i class="fas fa-plus"></i>
                    Aggiungi
                  </b-button>
                </span>
              </div>
            </template>
            <div class="b-table-sticky-header"
              style="height: 300px !important; overflow-y: scroll; border-radius: 8px !important;">
              <b-table sticky-header stacked=" xl" striped hover itemscope :items="jsonData.prestazioni"
                :fields="fields" :current-page="1" :per-page="1000" sort-icon-left head-variant="light"
                class="sa-b-table">
                <template #cell(index)="row">
                  {{ row.index + 1 }}
                </template>
                <template #cell(prestazione)="row">
                  <span style="width: 100% !important;">{{ row.item.descrizionePrestazione }}</span>
                  <br />
                  <span style="font-size: small; font-weight: 700;">{{ row.item.codicePrestazione }}</span>
                </template>
                <template #cell(actions)="row">
                  <b-button size="sm" class="mr-2" variant="outline-primary outline-primary-noborder pull-right "
                    @click="onClickModificaPrestazioneAgenda(row)">
                    <i class="bi bi-pencil"></i>
                  </b-button>
                  <b-button size="sm" variant="outline-danger outline-secondary-noborder pull-right "
                    @click="onClickEliminaPrestazione(row)">
                    <i class="far fa-trash-alt"></i>
                  </b-button>
                </template>
              </b-table>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <div class="sa-free-page-footer">
      <agenda-nuova-data-modal-component ref="cmpAgendaNuovaDataModalComponent" @addParametro="addParametro"
        @modificaParametro="onModificaParametro"></agenda-nuova-data-modal-component>
      <agenda-nuova-ripartizione-modal-component ref="cmpAgendaNuovaRipartizioneModalComponent"
        @addFasciaOraria="addFasciaOraria"
        @modificaFasciaOraria="onModificaFasciaOraria"></agenda-nuova-ripartizione-modal-component>
      <agenda-nuova-prestazione-modal-component ref="cmpAgendaNuovaPrestazioneModalComponent"
        @addPrestazione="onAddPrestazione" @modificaPrestazione="onModificaPrestazione"
        :durataAppuntamento="jsonData.durataAppuntamento"></agenda-nuova-prestazione-modal-component>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import AgendaNuovaDataModalComponent from "./AgendaNuovaDataModalComponent.vue";
import AgendaNuovaRipartizioneModalComponent from "./AgendaNuovaRipartizioneModalComponent.vue";
import AgendaNuovaPrestazioneModalComponent from "./AgendaNuovaPrestazioneModalComponent.vue";
import UtilityMixin from "../../utility/UtilityMixin";

export default {
  mixins: { UtilityMixin },
  components: { AgendaNuovaDataModalComponent, AgendaNuovaRipartizioneModalComponent, AgendaNuovaPrestazioneModalComponent },
  mounted: function () {
    let me = this;
    me.loadPresidi();
    if (this.$route.params.id != null) {
      me.id = this.$route.params.id;
      me.linkedit = "/agende/edit/" + me.id;
      me.loadData();
    }
    this.loadDataSpecializzazioni();
    this.loadDataTipologieAgende();
  },
  data() {
    return {
      pathResourceStrutture: "/strutture",
      strutturaOptions: [],
      presidiOptions: [],
      fields: [
        {
          label: "",
          key: "index",
          thStyle: "width: 2rem",
        },
        {
          label: "Codice e Descrizione",
          key: "prestazione",
        },
        {
          label: "Costo",
          key: "costo",
          thStyle: "width: 2rem",
          formatter: (value) => {
            if (!value && value !== 0) return '€ 0,00';
            return '€ ' + Number(value).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ".");
          }
        },
        {
          label: "Durata",
          key: "durata",
          thStyle: "width: 2rem",
          formatter: (value) => {
            if (!value || isNaN(value)) return '0m';

            const ore = Math.floor(value / 60);
            const minuti = value % 60;

            if (ore > 0) {
              return `${ore}h ${minuti > 0 ? minuti + 'm' : ''}`.trim();
            }

            return `${minuti}m`;
          }
        },
        {
          label: "Qtn. Erogabile",
          key: "quantitaErogabile",
          thStyle: "width: 2rem",
        },
        {
          label: "",
          key: "actions",
        },
      ],
      struttura: null,
      specializzazioniOptions: [],
      tipologieAgendaOptions: [],
      pathResource: "/agende",
      showModalLoading: false,
      pathResourcePresidi: "/strutturepresidi",
      jsonData: {
        proprietario: null,
        titolo: null,
        prestazioni: [],
        descrizione: null,
        idPresidio: null,
        specializzazione: null,
        identificativo: "-",
        tipo: "GENERIC",
        extraTime: true,
        durataAppuntamento: 20,
        parametri: [],
      },
    };
  },
  methods: {
    init(jsonData) {
      this.jsonData = jsonData;
    },
    getJsonData() {
      return this.jsonData;

    },
    getDay(value) {
      let returnValue = "default";
      if (value)
        if (value.length === 1) {
          let localeData = moment().localeData();
          returnValue = localeData.weekdays()[value - 1]; // starts with 'Sonntag' (Sunday) but should be Montag/Monday
        } else if (value !== "default") {
          return value ? moment(new Date(new Number(value))).format("DD-MM-YYYY") : "";
        }


      return returnValue; //moment().isoWeekday(value);
    },
    loadData() {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + me.pathResource + "/";
      me.showModalLoading = true;
      if (me.id !== "-1") {
        axios
          .get(link + me.id)
          .then((response) => {
            me.jsonData = response.data.data;
            me.parametri = response.data.data.parametri;
            me.intervalli = response.data.data.parametri[0].intervalli;
            me.$emit("updateAgenda", me.jsonData);
            me.showModalLoading = false;
          })
          .catch(() => { });
      }
    },
    loadDataSpecializzazioni() {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + "/agendaspecializzazione";
      me.showModalLoading = true;
      axios
        .get(link)
        .then((response) => {
          this.specializzazioniOptions = response.data.data.list;

        })
        .catch(() => { });

    },


    loadDataTipologieAgende() {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + "/agendatipo";
      me.showModalLoading = true;
      axios
        .get(link)
        .then((response) => {
          this.tipologieAgendaOptions = response.data.data.list;

        })
        .catch(() => { });

    },
    onInput() {
      let me = this;
      me.$emit("updateAgenda", me.jsonData);
    },
    onClickRimuovi(parametro, i) {
      let me = this;
      console.log(parametro);

      me.$bvModal
        .msgBoxConfirm("Eliminare ' " + parametro.giorno + " ' Numero intervalli: " + parametro.intervalli.length, {
          title: "Eliminare Prestazione",
          buttonSize: "sm",
          okTitle: "SI",
          cancelTitle: "NO",
          okVariant: "danger",
          cancelVariant: "secondary",
          hideHeaderClose: true,
          footerClass: "p-2",
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.jsonData.parametri.splice(i, 1)
            me.$emit("updateAgenda", me.jsonData);
          }
        })
        .catch((error) => {
          console.log(error);
        });



    },
    loadPresidi() {
      let me = this;
      me.presidiOptions = [];
      UtilityMixin.methods.loadDataResources(me.pathResourcePresidi, null, me.resultLoadPresidiSuccess, me.resultLoadPresidiError);
    },
    resultLoadPresidiSuccess(response) {
      let me = this;
      me.presidiOptions = response.data.data.list;
      if (me.presidiOptions.length === 1) {
        me.jsonData.idPresidio = me.presidiOptions[0].id;
      }
      me.emitChange();
      this.$emit("afterLoadData");
    },
    resultLoadPresidiError(error) {
      this.$emit("afterLoadData", error);
    },
    onClickNuovoParametro() {
      let me = this;
      me.$refs.cmpAgendaNuovaDataModalComponent.nuovoParametro();
    },
    onClickModificaParametro(parametro, index) {
      console.log(parametro, index);
      let parameter = {
        parametro: parametro,
        index: index
      }

      this.$refs.cmpAgendaNuovaDataModalComponent.onModificaParametro(JSON.parse(JSON.stringify(parameter)));
    },
    onClickAggiungiFasciaOrario(parametro, index) {
      let me = this;
      let parameter = {
        parametro: parametro,
        index: index
      }
      me.$refs.cmpAgendaNuovaRipartizioneModalComponent.nuovoIntervalloTemporale(parameter);
    },
    onClickModificaIntervallo(intervallo, index, parametro, i) {
      console.log("intervallo", intervallo);
      console.log("index intervallo", index);
      console.log("parametro", parametro);
      console.log("index parametro", i);
      let parameter = {
        intervallo: intervallo,
        intervalloIndex: index,
        parametro: parametro,
        parametroIndex: i
      }
      this.$refs.cmpAgendaNuovaRipartizioneModalComponent.modificaIntervalloParametro(parameter);
    },



    addParametro(intervallo) {
      console.log(intervallo);

      let me = this;
      intervallo.idAgenda = me.jsonData.id;
      me.jsonData.parametri.push(JSON.parse(JSON.stringify(intervallo)));
    },
    onModificaParametro(parametro, row) {
      let index = row.index;
      if (this.jsonData.id != "-1") {
        parametro.idAgenda = this.jsonData.id;
      }
      this.jsonData.parametri.splice(index, 1, parametro);
      this.$emit("updateAgenda", this.jsonData);
    },
    addFasciaOraria(jsonData, index) {
      let intervalloSelezionato = this.jsonData.parametri[index];
      intervalloSelezionato.intervalli.push(JSON.parse(JSON.stringify(jsonData)));
      this.$emit("updateAgenda", this.jsonData);
    },
    onModificaFasciaOraria(fasciaOraria, intervalloIndex, parametroIndex) {
      let parametroSelzionato = this.jsonData.parametri[parametroIndex];
      parametroSelzionato.intervalli.splice(intervalloIndex, 1, fasciaOraria);
      this.$emit("updateAgenda", this.jsonData);
    },
    onClickNuovoPrestazioniAgenda() {
      let me = this;
      me.$refs.cmpAgendaNuovaPrestazioneModalComponent.nuovaPrestazione();
    },
    onClickModificaPrestazioneAgenda(item) {
      let me = this;
      me.$refs.cmpAgendaNuovaPrestazioneModalComponent.onModificaPrestazione(item);
    },
    onModificaPrestazione(item, row) {
      console.log(item, row);
      let index = row.index;
      if (this.jsonData.id != "-1") {
        item.idAgenda = this.jsonData.id;
      }
      this.jsonData.prestazioni.splice(index, 1, item);
      this.$emit("updateAgenda", this.jsonData);
    },
    onClickEliminaFasciaOrario(parametro, index) {
      let me = this;
      parametro.intervalli.splice(index, 1);
      me.$emit("updateAgenda", me.jsonData);
    },
    onAddPrestazione(prestazione) {
      let me = this;
      if (me.jsonData.id != "-1") {
        prestazione.idAgenda = me.jsonData.id;
      }
      me.jsonData.prestazioni.push(JSON.parse(JSON.stringify(prestazione)));
      me.$emit("updateAgenda", me.jsonData);
    },
    onClickEliminaPrestazione(row) {
      let me = this;
      me.$bvModal
        .msgBoxConfirm("Eliminare ' " + row.item.descrizionePrestazione + " '", {
          title: "Eliminare Prestazione",
          buttonSize: "sm",
          okTitle: "SI",
          cancelTitle: "NO",
          okVariant: "danger",
          cancelVariant: "secondary",
          hideHeaderClose: true,
          footerClass: "p-2",
          centered: true,
        })
        .then((value) => {
          if (value) {
            let index = row.index;
            me.jsonData.prestazioni.splice(index, 1);
            me.$emit("updateAgenda", me.jsonData);
          }
        })
        .catch((error) => {
          console.log(error);
        });

    },


  },
};
</script>

<style></style>
